import {
    keys as keysFn,
    forOwn as forOwnFn,
    assign as assignFn,
    merge as mergeFn,
    clone as cloneFn
} from "lodash-es";

export namespace object {

    /**
     * @description: 获取对象key
     * @param {any} obj
     * @return {*}
     */
    export function keys(obj?: any): string[] {
        return keysFn(obj);
    }

    /**
    * @description: 获取对象key
    * @param obj 迭代对象（属性值）
    * @param iteratee 每次迭代调用函数
    * @return obj 返回迭代对象
    */
    export function forOwn<T>(obj: T, iteratee?: _.ObjectIterator<T, any>): T {
        if (iteratee) {
            return forOwnFn(obj, iteratee);
        } else {
            return forOwnFn(obj);
        }
    }

    /**
     * @description: 对象合并
     * @param {TObject} object
     * @param {TSource} source
     * @return {*}
     */
    export function assign<TObject, TSource>(object: TObject, source: TSource): TObject & TSource {
        return assignFn(object, source);
    }

    /**
     * @description: 递归合并 sources 来源对象自身和继承的可枚举属性到 object 目标对象
     * @param {TObject} object 源对象
     * @param {TSource} source 所要合并对象
     * 注意：此方法会改变源对象, 源对象会与合并后对象一致
     * 后续的source对象属性会覆盖之前分配的属性
     */
    export function merge<TObject, TSource>(object: TObject, source: TSource): TObject & TSource {
        return mergeFn(object, source);
    }

    /**
     * 克隆对象
     * @param object
     * @returns 
     */
    export function clone<T>(object: T): T {
        return cloneFn(object);
    }
}
